import {
    PROCESS_TRANSFER_SALES,
    PROCESS_TRANSFER_SALES_ERROR,
    CLEAN_PROCESS_TRANSFER_SALES,
    CLEAN_PROCESS_TRANSFER_SALES_ERROR,
} from "_models/redux/types";

const initialState = {
    loaded: undefined,
    method: undefined,
    payload: undefined,
    status: undefined,
    state: undefined,
};

export default function (state = initialState, action) {
    switch (action.type) {
        case PROCESS_TRANSFER_SALES:
            return {
                ...state,
                loaded: true,
                method: action?.method || null,
                payload: action?.payload || {},
                status: action?.status || null,
                state: "success",
            };

        case PROCESS_TRANSFER_SALES_ERROR:
            return {
                ...state,
                loaded: true,
                payload: action?.payload || {},
                status: action?.status || null,
                state: "error",
            };

        case CLEAN_PROCESS_TRANSFER_SALES:
            return {
                ...state,
                loaded: false,
                payload: action?.payload || undefined,
                status: undefined,
                state: "success",
            };

        case CLEAN_PROCESS_TRANSFER_SALES_ERROR:
            return {
                ...state,
                loaded: false,
                payload: action?.payload || undefined,
                status: undefined,
                state: "error",
            };
        default:
            return state;
    }
}
